import React, { forwardRef } from 'react'
import qr from '../../assets/biztrade_logo/bizQR.png'
import logo from '../../assets/biztrade_logo/logo.png'
import classes from './InvoicePreview.module.css'

export const InvoicePreview = forwardRef(({ invoiceNumber, date, clientName, orderProducts, selectedOrder }, ref) => {
    const subtotal = selectedOrder?.Order?.sub_total_price || 0
    const delivery = selectedOrder?.Order?.delivery_charge || 0
    const discount = selectedOrder?.Order?.discount_percentage || 0
    const total = selectedOrder?.Order?.payable_price || 0

    return (
        <div ref={ref} className={classes.bodyPdf}>
            <div className={classes.page}>
                <div className={classes.invoiceHeader}>
                    <div className={classes.logoBox}>
                        <img src={logo} alt="Biztrade Logo" />
                    </div>
                    <div className={classes.companyInfo}>
                        <p className={classes.companyName}>Biztrade</p>
                        <p>Flat : B2, House - 06 (2nd Floor), Nam Village</p>
                        <p>Road - 02, Block - L, Chairman Bari</p>
                        <p>Banani, Dhaka, Dhaka-1213</p>
                        <p>contact@biztradebd.com</p>
                        <a href="https://biztradebd.com">
                            <p>https://biztradebd.com</p>
                        </a>
                    </div>
                </div>

                <div className={classes.infoSection}>
                    <div className={classes.infoBox}>
                        <h4>Invoice To</h4>
                        <p>
                            <strong>Buyer Name: </strong>
                            {clientName}
                        </p>
                        <p>
                            <strong>Phone No:</strong> {selectedOrder?.OrderShipment?.customer_phone}
                        </p>
                        <p>
                            <strong>Address: </strong>
                            {selectedOrder?.OrderShipment?.detail_address}
                        </p>
                    </div>
                    <div className={classes.infoBox}>
                        <h4>Invoice Details</h4>
                        <p>
                            <strong>Shop Name:</strong> {selectedOrder?.Seller?.page_name}
                        </p>
                        <p>
                            <strong>Order No:</strong> {invoiceNumber}
                        </p>
                        <p>
                            <strong>Date:</strong> {date}
                        </p>
                    </div>
                </div>

                <table className={classes.tablePdf}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Variant</th>
                            <th>Price</th>
                            <th>Qty</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderProducts?.OrderProduct?.map((item, idx) => {
                            const total = Number(item.order_quantity) * Number(item.final_product_price)
                            return (
                                <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{item.product_name}</td>
                                    <td>{item.order_variant || '--'}</td>
                                    <td>৳{Number(item.final_product_price).toFixed(2)}</td>
                                    <td>{item.order_quantity}</td>
                                    <td>৳{total.toFixed(2)}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                <div className={classes.summary}>
                    <div className={classes.paymentMethod}>
                        <p>Cash On Delivery</p>
                    </div>
                    <table className={classes.summaryTable}>
                        <tbody>
                            <tr>
                                <td>Subtotal</td>
                                <td>৳{subtotal}</td>
                            </tr>
                            <tr>
                                <td>Discount ({discount}%)</td>
                                <td>৳{selectedOrder?.Order?.discount_price}</td>
                            </tr>
                            {/* <tr>
                                <td>Total</td>
                                <td>৳{selectedOrder?.Order?.total_price}</td>
                            </tr> */}
                            <tr>
                                <td>Delivery Charge ({selectedOrder?.OrderShipment?.delivery_weight}Kg)</td>
                                <td>৳{delivery}</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Grand Total</strong>
                                </td>
                                <td>
                                    <strong>৳{total}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className={classes.notes}>
                    <p>Notes</p>
                    <p>
                        Thank You for Choosing Us. <br />
                        The primary service that Biztrade provides to SMEs in Bangladesh is a B2B marketplace where they
                        can advertise and sell their products and services both locally and internationally.
                    </p>
                </div>
                <div className={classes.notes}>
                    <p>Terms & Conditions</p>
                    <p>
                        The payment of the amount mentioned above is due and has to be made in advance via: Bank, Bkash
                    </p>
                </div>

                <div className={classes.bizQR}>
                    <img src={qr} alt="" />
                </div>

                <div className={classes.servicesFooter}>
                    <div className={classes.servicesList}>
                        <p className={classes.servicesTitle}>Our Services:</p>
                        <p>SME Loan</p>
                        <p>|</p>
                        <p>Buyer Matchmaking</p>
                        <p>|</p>
                        <p>Legal & Licensing</p>
                        <p>|</p>
                        <p>Digital Marketing</p>
                    </div>
                    <p className={classes.developedBy}>Developed by Biztrade</p>
                </div>
            </div>
        </div>
    )
})
